import * as React from 'react';

const EmptyFiltersIcon = () => (
  <svg
    width="48"
    height="36"
    viewBox="0 0 48 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="36" rx="1" fill="white" />
    <rect
      x="0.5"
      y="0.5"
      width="47"
      height="35"
      rx="0.5"
      stroke="#0E1323"
      strokeOpacity="0.08"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 15H15C14.4 15 14 14.6 14 14C14 13.4 14.4 13 15 13H17H17.2C17.6 11.8 18.7 11 20 11C21.3 11 22.4 11.8 22.8 13H23H33C33.6 13 34 13.4 34 14C34 14.6 33.6 15 33 15H23H22.8C22.4 16.2 21.3 17 20 17C18.7 17 17.6 16.2 17.2 15H17ZM21 14C21 13.4 20.6 13 20 13C19.4 13 19 13.4 19 14C19 14.6 19.4 15 20 15C20.6 15 21 14.6 21 14ZM31 21H33C33.6 21 34 21.4 34 22C34 22.6 33.6 23 33 23H31H30.8C30.4 24.2 29.3 25 28 25C26.7 25 25.6 24.2 25.2 23H25H15C14.4 23 14 22.6 14 22C14 21.4 14.4 21 15 21H25H25.2C25.6 19.8 26.7 19 28 19C29.3 19 30.4 19.8 30.8 21H31ZM27 22C27 22.6 27.4 23 28 23C28.6 23 29 22.6 29 22C29 21.4 28.6 21 28 21C27.4 21 27 21.4 27 22Z"
      fill="#0E1323"
      fillOpacity="0.5"
    />
  </svg>
);
export default EmptyFiltersIcon;
